import ActionsOnEntities from "./actions-on-entities";
export default ActionsOnEntities;
